import { useSingleState } from "@ntropy/hooks";

export const useAuthModalState = () => {
    return useSingleState("auth-state", false);
}